"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  display: block;\n  width: ", ";\n  height: ", ";\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  z-index: 1;\n  background: none;\n  border: none;\n  padding: ", ";\n  margin: 0;\n\n  svg {\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    width: ", ";\n    height: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  @media (hover: hover) {\n    &:hover:before {\n      content: \"\";\n      background: ", ";\n      ", "\n      height: ", ";\n      width: ", ";\n      border-radius: 50%;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translateX(-50%) translateY(-50%);\n      z-index: -1;\n    }\n  }\n"], ["\n  display: block;\n  width: ", ";\n  height: ", ";\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  z-index: 1;\n  background: none;\n  border: none;\n  padding: ", ";\n  margin: 0;\n\n  svg {\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    width: ", ";\n    height: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  @media (hover: hover) {\n    &:hover:before {\n      content: \"\";\n      background: ", ";\n      ", "\n      height: ", ";\n      width: ", ";\n      border-radius: 50%;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translateX(-50%) translateY(-50%);\n      z-index: -1;\n    }\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["opacity: 0.1;"], ["opacity: 0.1;"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.button.withConfig({
  displayName: "CloseIcon__Container",
  componentId: "sc-1vgv1gh-0"
})(_templateObject, function (props) {
  return props.size ? props.size : "35px";
}, function (props) {
  return props.size ? props.size : "35px";
}, function (props) {
  return props.top ? props.top : "1px";
}, function (props) {
  return props.right ? props.right : "1px";
}, function (props) {
  return props.padding ? props.padding : "10";
}, function (props) {
  return props.padding ? props.padding : "10px";
}, function (props) {
  return props.padding ? props.padding : "10px";
}, function (props) {
  return props.iconSize ? props.iconSize : "15px";
}, function (props) {
  return props.iconSize ? props.iconSize : "15px";
}, function (props) {
  return props.color ? props.color : "black";
}, function (props) {
  return props.hoverColor ? props.theme.colors[props.hoverColor] : 'rgba(0, 173, 239, 0.1)';
}, function (props) {
  return props.hoverColor && (0, _styledComponents.css)(_templateObject2);
}, function (props) {
  return props.backgroundSize ? props.backgroundSize : "37.5px";
}, function (props) {
  return props.backgroundSize ? props.backgroundSize : "37.5px";
});

var CloseIcon = function CloseIcon(props) {
  return _react2.default.createElement(
    Container,
    props,
    _react2.default.createElement(
      "svg",
      {
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 17 17",
        enableBackground: "new 0 0 16 16"
      },
      _react2.default.createElement("path", {
        d: "M9.2,8.5l7.1-7.1c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7, 0L8.5,7.8L1.4,0.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0, 0.7l7.1,7.1l-7.1,7.1c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1, 0.2,0.1,0.4,0.1s0.3,0,0.4-0.1l7.1-7.1l7.1,7.1c0.1, 0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5, 0-0.7L9.2,8.5z"
      })
    )
  );
};

exports.default = CloseIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/CloseIcon.js
// module id = 419
// module chunks = 168707334958949